import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useGetPlanningPendency, useGetPlanningResource, useGetSkuListInPlanning } from '../../hooks/usePlanning';
import { Modal, Button, Row, Col, Badge, notification, Spin, Checkbox } from 'antd';
import ExportExcel from '../../utils/Export-Excel';
import { FilterOutlined } from '@ant-design/icons';
import { v4 as uuid } from 'uuid';
import CountDivider from './CountDivider';
import PendencyGroupTable, { AssignBayMenu, SelectionCount, createSelectionStore } from './PendencyGroupTable';
import BayView from './BayView';
import Filters from './Filters';
import BayDataPivotSelector from './BayDataPivotSelector';
import SkuListModal from './SkuListing/SkuListModal';
import { assignGroupToBay, assignGroupsToBay, clearBay, removeGroupFromBay } from './planningAssign';
import './planningStyle.scss';

export default function CreateGuidelines({
    open,
    onCancel,
    onOk,
    companyCode,
    selectedModels,
    selectedBays,
    ExcludeLinks,
    splitByShootType,
    splitByOrder,
    includePendingAtRawQC,
    splitByAssignedModel,
    includeSpecialCategory,
    showOnlyDDApproved,
    showCSA,
    showSLAPending,
    splitByPresets,
    dateString = '2023-09-15',
    splitByDaysSinceInbound,
}) {
    // console.log('createGuidelines', { splitByShootType, splitByOrder, includePendingAtRawQC, showOnlyDDApproved, showSLAPending });
    const [unfilteredPlanningData, setUnfilteredPlanningData] = useState([]);
    const [planningData, setPlanningData] = useState([]);
    const [OriginalplanningData, setOriginalPlanningData] = useState([]);
    const [BaysList, setBaysList] = useState([]);
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
    const [filters, setFilters] = useState({});
    const [appliedFilters, setAppliedFilters] = useState({});

    const [showBayDataPivot, setShowBayDataPivot] = useState(false);
    const [bayDataPivotKeys, setBayDataPivotKeys] = useState([]);

    const [showCountDivider, setShowCountDivider] = useState(false);
    const [dragDropResults, setDragDropResults] = useState(null);
    const [askForCount, setAskForCount] = useState(true);
    const pendencySelection = useMemo(() => createSelectionStore(), []);
    const assignMenuRef = useRef(null);

    const [skuListData, setSkuListData] = useState([]);
    const [skuModal, setSkuModal] = useState({ flag: false, details: null });
    const closeSkuModal = () => {
        setSkuModal({ flag: false, details: null });
        setSkuListData([]);
    };

    const { mutate: fetchPlanningSku } = useGetSkuListInPlanning(onFetched, onFetchFail);

    function onFetched(data) {
        console.log(data);
        setSkuListData(data?.skus);
    }

    function onFetchFail(err) {
        console.log(err);
        notification.error({ message: 'Error', description: 'Some error occured' });
        closeSkuModal();
    }

    const { data: bayData, isFetching: isFetchingBays, isFetched: isFetchedBays, refetch: refetchBays } = useGetPlanningResource(companyCode, 'Bays');

    const onSuccess = () => { };

    const { data, refetch, isFetching, isFetched, isSuccess } = useGetPlanningPendency(
        companyCode,
        selectedModels,
        selectedBays,
        ExcludeLinks,
        true,
        splitByShootType,
        splitByOrder,
        includePendingAtRawQC,
        showOnlyDDApproved,
        showCSA,
        showSLAPending,
        splitByAssignedModel,
        includeSpecialCategory,
        splitByPresets,
        splitByDaysSinceInbound,
        onSuccess
    );

    const HandleApplyFilter = data => {
        setAppliedFilters(data);
        console.log('HandleApplyFilter', { data, unfilteredPlanningData, appliedFilters });
    };

    const GetFilteredPlanningData2 = (data, filter) => {
        const result = data?.filter(dataItem => {
            const { group } = dataItem;
            return Object.keys(filter)?.every(key => {
                const value = filter[key];
                return value.includes(group[key]);
            });
        });
        // console.log('GetFilteredPlanningData2', { result });
        return result;
    };

    const GetFilteredPlanningData = useMemo(() => {
        return (data, filter) => {
            return GetFilteredPlanningData2(data, filter);
        };
    }, [appliedFilters, planningData]);

    // useEffect(() => {
    //     console.log('useEffect appliedFilter', { appliedFilters });
    //     // GetFilteredPlanningData(planningData, appliedFilters);
    // }, [appliedFilters]);

    useEffect(() => {
        const filters = {};
        if (!isFetching && isFetched) {
            const planningDataModified = data?.data
                ?.map(item => {
                    console.log({ group: item?.group });
                    item.id = 'group' + uuid();
                    Object.keys(item?.group).map(key => {
                        if (!filters[key]) {
                            filters[key] = [item?.group[key]];
                        } else {
                            if (!filters[key].includes(item?.group[key])) {
                                filters[key].push(item?.group[key]);
                            }
                        }
                    });

                    return item;
                })
                .sort((a, b) => b?.data?.length - a?.data?.length);
            console.log('useEffect:[data]', { filters });
            if (!!planningDataModified && planningDataModified?.length > 0) {
                const copy = JSON.parse(JSON.stringify(planningDataModified));
                setOriginalPlanningData(copy);
                const copy2 = JSON.parse(JSON.stringify(planningDataModified));
                setPlanningData(copy2);
                setUnfilteredPlanningData(JSON.parse(JSON.stringify(planningDataModified)));
                setFilters(filters);
                setAppliedFilters({});
            }
        } else {
            setOriginalPlanningData([]);
            setPlanningData([]);
            setFilters({});
            setAppliedFilters({});
        }
    }, [data, isFetched, isFetching]);

    useEffect(() => {
        const baydataModified = bayData?.data?.map(d => {
            d.assigned = [];
            d.id = 'bay' + uuid();
            return d;
        });
        setBaysList(baydataModified);
    }, [bayData]);

    useEffect(() => {
        if (skuModal.flag) {
            fetchPlanningSku(skuModal.details.data);
        }
    }, [skuModal]);

    const ProcessDragDropEventResults = useCallback(
        (results, count) => {
            const next = assignGroupToBay(BaysList, planningData, {
                bayId: results?.destination?.droppableId,
                groupId: results?.draggableId,
                count,
            });
            setBaysList(next.bays);
            setPlanningData(next.planning);
            setDragDropResults(null);
            if (results?.draggableId) {
                pendencySelection.clear([results.draggableId]);
            }
        },
        [BaysList, pendencySelection, planningData]
    );

    const beginAssignToBay = useCallback(
        (groupIdOrIds, bayId) => {
            if (!bayId) {
                return;
            }

            const groupIds = (Array.isArray(groupIdOrIds) ? groupIdOrIds : [groupIdOrIds]).filter(Boolean);
            if (!groupIds.length) {
                return;
            }

            const clearAssignedSelection = () => {
                pendencySelection.clear(groupIds);
            };

            // Multi-select: always assign each group's full count, never ask.
            if (groupIds.length > 1) {
                const next = assignGroupsToBay(BaysList, planningData, { bayId, groupIds });
                setBaysList(next.bays);
                setPlanningData(next.planning);
                clearAssignedSelection();
                return;
            }

            const groupId = groupIds[0];
            const planningDataIndex = planningData.findIndex(d => d.id == groupId);
            if (planningDataIndex < 0) {
                return;
            }

            const count = planningData[planningDataIndex].data?.length ?? 0;
            if (count <= 0) {
                return;
            }

            const results = {
                draggableId: groupId,
                destination: { droppableId: bayId },
            };

            if (askForCount) {
                setDragDropResults(results);
                setShowCountDivider(true);
                return;
            }

            ProcessDragDropEventResults(results, count);
            clearAssignedSelection();
        },
        [BaysList, ProcessDragDropEventResults, askForCount, pendencySelection, planningData]
    );

    const HandleDelete = useCallback(
        (bayId, planningDataId) => {
            const next = removeGroupFromBay(BaysList, planningData, OriginalplanningData, {
                bayId,
                groupId: planningDataId,
            });
            setBaysList(next.bays);
            setPlanningData(next.planning);
        },
        [BaysList, OriginalplanningData, planningData]
    );

    const HandleClearAll = useCallback(
        bayId => {
            const next = clearBay(BaysList, planningData, OriginalplanningData, bayId);
            setBaysList(next.bays);
            setPlanningData(next.planning);
        },
        [BaysList, OriginalplanningData, planningData]
    );

    const openAssignMenu = useCallback((event, record) => {
        assignMenuRef.current?.open(event, record);
    }, []);

    const handleAssignFromMenu = useCallback(
        (groupIds, bayId) => {
            beginAssignToBay(groupIds, bayId);
        },
        [beginAssignToBay]
    );

    const handleDropGroup = useCallback(
        (groupIds, bayId) => {
            beginAssignToBay(groupIds, bayId);
        },
        [beginAssignToBay]
    );

    const OnFormSubmit = bayWiseList => {
        bayWiseList = bayWiseList?.filter(d => d?.assigned?.length > 0);
        const result = bayWiseList?.map(bay => {
            // bay = {assigned = [{data, group,id}], filters, capacity, id ,name}
            // GuidelineName, skuIds, description
            const GuidelineName = `${bay.name} | ${dateString}`;
            const skuList = [];
            let description = '';
            bay?.assigned?.map(({ data, group }) => {
                if (data?.length > 0) {
                    skuList.push(...data);
                }
                if (group != null) {
                    Object.keys(group)?.map(key => {
                        const [path, keyStr] = key.split('.');
                        const value = group[key];
                        description += `${value}, `;
                    });
                    description += ` (${data?.length}) \n`;
                }
            });
            return {
                GuidelineName,
                skuList,
                description,
            };
        });
        console.log({ bayWiseList, result });
        onOk(result);
    };

    const GetTotalPendingCount = planningData => {
        const assignedCount = planningData?.reduce((total, current, currIndex, arr) => {
            total += current?.data?.length;
            return total;
        }, 0);
        return assignedCount;
    };

    const filteredPendency = GetFilteredPlanningData(planningData, appliedFilters);
    return (
        <>
            <Modal
                title={`Plan Shoot Bay Wise for ${dateString}`}
                open={open}
                onCancel={onCancel}
                onOk={() => OnFormSubmit(BaysList)}
                width="100%"
                style={{
                    top: '10px',
                    height: '85vh',
                }}
            >
                {' '}
                <Spin spinning={skuModal.flag}>
                    <>
                        <Row
                            style={{
                                width: '100%',
                                height: '85vh',
                            }}
                        >
                            <Col
                                span={12}
                                style={{
                                    height: '85vh',
                                    borderRadius: '13px 13px 0 0',
                                    border: '1px solid #777',
                                    position: 'relative',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexFlow: 'column nowrap',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {/* Header */}
                                    <div
                                        style={{
                                            width: '100%',
                                            textAlign: 'center',
                                            borderRadius: '13px 13px 0 0',
                                            backgroundColor: 'gray',
                                            color: 'white',
                                            marginBottom: '10px',
                                            display: 'flex',
                                            justifyContent: 'space-evenly',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <h2>{`Pendency Data (${GetTotalPendingCount(filteredPendency)})`}</h2>
                                        <h3>{`Groups count: ${filteredPendency?.length}`}</h3>
                                        <SelectionCount store={pendencySelection} />
                                        <Checkbox
                                            checked={askForCount}
                                            onChange={e => setAskForCount(e.target.checked)}
                                            style={{ color: 'white' }}
                                        >
                                            Ask for count
                                        </Checkbox>
                                        <Badge count={Object.keys(appliedFilters)?.length || 0} size="small">
                                            <Button
                                                icon={<FilterOutlined />}
                                                onClick={() => setIsFilterPanelOpen(true)}
                                            >
                                                Filters
                                            </Button>
                                        </Badge>
                                        <ExportExcel
                                            excelData={planningData.map(obj => {
                                                const { data, group } = obj;
                                                return { ...group, count: data?.length };
                                            })}
                                            fileName={'Pending Data'}
                                            data={planningData}
                                        />
                                    </div>
                                    {/* Pendency Data */}
                                    <div
                                        style={{
                                            height: '80vh',
                                            overflow: 'hidden',
                                            position: 'relative',
                                            paddingBottom: 8,
                                        }}
                                    >
                                        <PendencyGroupTable
                                            data={filteredPendency || []}
                                            setSkuModal={setSkuModal}
                                            loading={isFetching}
                                            onAssignContextMenu={openAssignMenu}
                                            selectable
                                            selectionStore={pendencySelection}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col
                                span={12}
                                style={{
                                    overflow: 'auto',
                                    height: '85vh',
                                    overflow: 'auto',
                                    display: 'flex',
                                    flexFlow: 'row wrap',
                                    // padding: '10px',
                                    backgroundColor: 'white',
                                    border: '1px solid #777',
                                    borderRadius: '13px 13px 0 0',
                                    // borderRadius: '20px',
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                        backgroundColor: '#999',
                                        marginBottom: '5px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyItems: 'flex-end',
                                        position: 'relative',
                                    }}
                                >
                                    <Button
                                        style={{
                                            position: 'absolute',
                                            right: '20px',
                                            backgroundColor: 'lightslategrey',
                                            color: 'white',
                                        }}
                                        type="default"
                                        onClick={() => setShowBayDataPivot(true)}
                                    >
                                        Edit scorecard fields
                                    </Button>
                                </div>
                                {!!BaysList &&
                                    !!BaysList?.length &&
                                    BaysList.map(bay => (
                                        <div key={bay.id} style={{ width: '100%' }}>
                                            <BayView
                                                bay={bay}
                                                HandleDelete={HandleDelete}
                                                onClearAll={HandleClearAll}
                                                pivotkeys={bayDataPivotKeys}
                                                setSkuModal={setSkuModal}
                                                onDropGroup={handleDropGroup}
                                            />
                                        </div>
                                    ))}
                            </Col>
                        </Row>
                        <AssignBayMenu ref={assignMenuRef} bays={BaysList} onAssign={handleAssignFromMenu} />

                        <Modal
                            title="Filters"
                            open={isFilterPanelOpen}
                            onCancel={() => setIsFilterPanelOpen(false)}
                            footer={null}
                            width={720}
                            destroyOnClose
                        >
                            <Filters
                                defaultFilters={appliedFilters}
                                filters={filters}
                                applyFilters={HandleApplyFilter}
                                onCloseFilterPanel={() => setIsFilterPanelOpen(false)}
                            />
                        </Modal>

                        <CountDivider
                            key={dragDropResults?.draggableId || 'count-divider'}
                            open={showCountDivider && !!dragDropResults}
                            onOK={count => {
                                setShowCountDivider(false);
                                ProcessDragDropEventResults(dragDropResults, count);
                            }}
                            onCancel={() => {
                                setShowCountDivider(false);
                                setDragDropResults(null);
                            }}
                            dragDropResults={dragDropResults}
                            planningData={planningData}
                        />
                        {!!showBayDataPivot && (
                            <BayDataPivotSelector
                                open={showBayDataPivot}
                                onCancel={() => setShowBayDataPivot(false)}
                                filters={filters}
                                onChange={keys => {
                                    setBayDataPivotKeys(keys);
                                    setShowBayDataPivot(false);
                                }}
                                selectedKeyDefault={bayDataPivotKeys}
                                key="BayDataPivotSelector"
                            />
                        )}
                    </>
                    {skuModal?.flag && skuListData?.length > 0 && (
                        <SkuListModal
                            key={JSON.stringify(skuModal?.details)}
                            skuModal={skuModal}
                            closeSkuModal={closeSkuModal}
                            skuData={skuListData}
                        />
                    )}
                </Spin>
            </Modal>
        </>
    );
}
